document.addEventListener("click",function(e){const b=e.target.closest("[data-qty]");if(!b)return;const i=document.querySelector("#Quantity");if(!i)return;let n=parseInt(i.value||1);i.value=Math.max(1,n+(b.dataset.qty==="plus"?1:-1));});
// Mobile nav toggle
(function(){
  var btn = document.getElementById('mobileNavToggle');
  var drawer = document.getElementById('mobileDrawer');
  if(!btn || !drawer) return;
  btn.addEventListener('click', function(){
    var open = drawer.classList.toggle('open');
    btn.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  drawer.querySelectorAll('a').forEach(function(a){
    a.addEventListener('click', function(){
      drawer.classList.remove('open');
      btn.classList.remove('open');
      btn.setAttribute('aria-expanded','false');
    });
  });
})();

// --- Product page: gallery thumbnail swap ---
(function(){
  var main = document.getElementById('PdpMainImage');
  var thumbs = document.querySelectorAll('.pdp-thumb');
  if(!main || !thumbs.length) return;
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      main.src = t.dataset.full;
      thumbs.forEach(function(o){ o.classList.remove('active'); });
      t.classList.add('active');
    });
  });
})();

// --- Product page: variant picker + price/availability updates ---
(function(){
  var form = document.getElementById('PdpForm');
  var jsonEl = document.getElementById('PdpVariantsJson');
  if(!form || !jsonEl) return;

  var variants;
  try { variants = JSON.parse(jsonEl.textContent); } catch(e) { return; }
  if(!variants || !variants.length) return;

  var variantIdInput = document.getElementById('PdpVariantId');
  var priceEl = document.getElementById('PdpPrice');
  var compareEl = document.getElementById('PdpComparePrice');
  var saveBadge = document.getElementById('PdpSaveBadge');
  var addBtn = document.getElementById('PdpAddToCart');
  var addBtnText = document.getElementById('PdpAddToCartText');
  var mainImage = document.getElementById('PdpMainImage');
  var stickyPrice = document.getElementById('PdpStickyPrice');
  var stickyAddBtn = document.getElementById('PdpStickyAddToCart');

  function money(cents){
    return (cents/100).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
  }

  var optionGroups = {};
  document.querySelectorAll('.pdp-option-values input[type="radio"]').forEach(function(input){
    var idx = input.dataset.optionIndex;
    optionGroups[idx] = optionGroups[idx] || [];
    optionGroups[idx].push(input);
  });
  var optionIndexes = Object.keys(optionGroups).sort(function(a,b){ return a - b; });
  if(!optionIndexes.length) return;

  function getSelectedOptions(){
    return optionIndexes.map(function(idx){
      var checked = optionGroups[idx].filter(function(i){ return i.checked; })[0];
      return checked ? checked.value : null;
    });
  }

  function findVariant(options){
    return variants.filter(function(v){
      return options.every(function(val, i){ return val === null || v['option' + (i+1)] === val; });
    })[0];
  }

  function updateAvailability(){
    var selected = getSelectedOptions();
    optionIndexes.forEach(function(idx, dim){
      optionGroups[idx].forEach(function(input){
        var testOptions = selected.slice();
        testOptions[dim] = input.value;
        var match = variants.filter(function(v){
          return testOptions.every(function(val, i){ return val === null || v['option' + (i+1)] === val; });
        });
        var anyAvailable = match.some(function(v){ return v.available; });
        input.disabled = match.length > 0 && !anyAvailable;
      });
    });
  }

  function updateForVariant(){
    var selected = getSelectedOptions();
    var variant = findVariant(selected);
    if(!variant) return;

    if(variantIdInput) variantIdInput.value = variant.id;

    if(priceEl) priceEl.textContent = 'R' + money(variant.price);
    if(compareEl){
      if(variant.compare_at_price && variant.compare_at_price > variant.price){
        compareEl.textContent = 'R' + money(variant.compare_at_price);
        compareEl.style.display = '';
        if(saveBadge){
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          saveBadge.textContent = 'SAVE ' + pct + '%';
          saveBadge.style.display = '';
        }
      } else {
        compareEl.style.display = 'none';
        if(saveBadge) saveBadge.style.display = 'none';
      }
    }
    if(stickyPrice) stickyPrice.textContent = 'R' + money(variant.price);

    var available = variant.available;
    if(addBtn) addBtn.disabled = !available;
    if(addBtnText) addBtnText.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    if(stickyAddBtn){
      stickyAddBtn.disabled = !available;
      stickyAddBtn.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    }

    if(mainImage && variant.featured_image && variant.featured_image.src){
      mainImage.src = variant.featured_image.src.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_1200x$1$2');
    }

    updateAvailability();
  }

  optionIndexes.forEach(function(idx){
    optionGroups[idx].forEach(function(input){
      input.addEventListener('change', updateForVariant);
    });
  });

  updateAvailability();

  if(stickyAddBtn){
    stickyAddBtn.addEventListener('click', function(){
      if(form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }
})();

// --- Product page: mobile sticky add-to-cart bar visibility ---
(function(){
  var bar = document.getElementById('PdpStickyBar');
  var trigger = document.getElementById('PdpAddToCart');
  if(!bar || !trigger || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      bar.classList.toggle('show', !entry.isIntersecting);
    });
  }, { rootMargin: '0px 0px -10% 0px' });
  observer.observe(trigger);
})();
